import { createNetworkActions } from '../../utils/actions-utils';
import keyMirror from 'keymirror';

const FeatureFlagActions = keyMirror({
  getFeatureFlags: null,
});

export const getFeatureFlagsAction = createNetworkActions(FeatureFlagActions.getFeatureFlags);
